<script lang="ts">
  import type { DatasetAggregations } from "../../../models/dataset.interface";

  export let datasetAggregations: DatasetAggregations;
  export let resultAggregations: DatasetAggregations;

  const datatypes = JSON.parse(document.getElementById("dataTypes").innerHTML).dataTypes;
  const datasetId = JSON.parse(document.getElementById("datasetMetadata").innerHTML).id;

  function transform(input: number): string {
    let transformedValue = "";

    if (input != null) {
      if (input.toString().length >= 3 && input.toString().length <= 6) {
        transformedValue = `${(input / 1000).toFixed(2)} KB`;
      } else if (input.toString().length >= 6 && input.toString().length <= 9) {
        transformedValue = `${(input / 1000000).toFixed(2)} MB`;
      } else if (input.toString().length >= 9 && input.toString().length <= 12) {
        transformedValue = `${(input / 1000000000).toFixed(2)} GB`;
      } else {
        transformedValue = `${(input / 1000000000000).toFixed(2)} TB`;
      }
    }

    return transformedValue;
  }

  function transformDate(input: string): string {
    return input ? input.slice(0, 10) : "undefined";
  }
</script>

<div class="row">
  <div class="col-md-12 col-lg col-sm-12 mb-2">
    <div class="pt-3 ps-3">
      <div>
        <h2>Search Result Summary and List View</h2>
      </div>
      <div>
        {#if datasetId === "nexrad-level-1-event-data"}
          <p class="lead">View a summary and list of your results based on the provided search
            options.
            Hover the tile for a description about the weather event. </p>
        {:else}
          <p class="lead">View a summary and list of your results based on the provided search
            options.</p>
        {/if}
      </div>
    </div>

    <!-- used for testing the store -->
    <!--{#each $selectedFileList as item(item.name)}-->
    <!--    {item.name}-->
    <!--{/each}-->

  </div>
  <!-- summary based on dataset -->
  <div class="col-md-12 col-lg-5 col-sm-12 p-4">
  <div class="pt-3 ps-3">
    <div class="container text-start">
      <div class="row row-cols-2">
        <div class="col">
          <div class="row mt-4">
            <div class="col table-border me-4 ps-0 pt-2 mb-2">
              <small class="text-muted">Result File Size</small>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col ps-0">
              <strong>{transform(resultAggregations?.totalFileSize)} of {transform(datasetAggregations?.totalFileSize)}</strong>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row mt-4">
            <div class="col table-border me-4 ps-0 pt-2 mb-2">
              <small class="text-muted">Result File Count</small>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col ps-0">
              <strong>{resultAggregations?.count} of {datasetAggregations?.count}</strong>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row mt-1">
            <div class="col table-border me-4 ps-0 pt-2 mb-2">
              <small class="text-muted">Period of Record</small>
            </div>
          </div>
          <div class="row">
            <div class="col me-4 ps-0 mb-2">
              <small class="text-muted">Results</small>
              <br/>
              <strong>
                {transformDate(resultAggregations?.startDate)} to {transformDate(resultAggregations?.endDate)}
              </strong>
              <br/>
              <small class="text-muted">Available</small>
              <br/>
              <strong>
                {transformDate(datasetAggregations?.startDate)} to {transformDate(datasetAggregations?.endDate)}
              </strong>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row mt-1">
            <div class="col table-border me-4 ps-0 pt-2 mb-2">
              {#if datasetId === "nexrad-level-1-event-data"}
                <small class="text-muted">VCP's</small>
              {:else}
                <small class="text-muted">Datatypes</small>
              {/if}
            </div>
          </div>
          <div class="row">
            <!--                        <div class="col me-4 ps-0 mb-2">-->
            <!--                            <strong>{resultAggregations?.dataTypes.buckets.length} Data Types</strong>-->
            <!--                        </div>-->
          </div>
          <div class="row mb-4">
            <div class="col ps-0">
              <div class="dropdown">
                <button class="btn ae-outline-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false" data-bs-offset="0,10">
                  {#if datasetId === "nexrad-level-1-event-data"}
                    <strong>{datatypes?.length || 0} VCP's</strong>
                  {:else}
                    <strong>{datatypes?.length || 0} Data Types</strong>
                  {/if}

                </button>
                <ul class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
                  {#each datatypes || [] as dt}
                    <li>
                      <span class="dropdown-item-text text-muted small">
                        <!--   condition for nexrad level 1  -->
                        {#if dt.name.includes("VCP")}
                          {dt.name}
                        {:else}
                          {dt.name} ({dt.id})
                        {/if}
                      </span>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                  {/each}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<style>
    .table-border {
        border-top: 1px solid #d1d1d1;
    }
</style>
